import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Reveal } from './Reveal';
import { SITE } from '../data/site';

const CTASection = ({
  title = 'Ready to Transform Your Backyard?',
  text = "Let's create an outdoor space designed for the way you live — built by a local team with 22+ years of Nebraska craftsmanship.",
  testId = 'cta-section',
}) => (
  <section data-testid={testId} className="noise-dark relative overflow-hidden bg-graphite py-24 md:py-32">
    <div className="container-site relative z-10">
      <div className="max-w-3xl">
        <Reveal>
          <p className="overline-label">Free On-Site Consultation</p>
          <h2 className="mt-4 font-serif text-4xl font-medium leading-[1.05] tracking-tight text-paper sm:text-5xl lg:text-6xl">{title}</h2>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-paper/70">{text}</p>
          <div className="mt-10 flex flex-wrap gap-4">
            <Link to="/get-a-quote/" data-testid={`${testId}-quote-btn`} className="btn-primary">Get a Free Quote</Link>
            <a href={SITE.phoneHref} data-testid={`${testId}-call-btn`} className="btn-outline-light">Call {SITE.phone}</a>
          </div>
        </Reveal>
      </div>
      <div className="pointer-events-none absolute -right-10 bottom-0 hidden select-none font-serif text-[16rem] italic leading-none text-paper/5 lg:block" aria-hidden="true">
        outdoors
      </div>
    </div>
  </section>
);

export const InlineCTA = ({ text = 'Ready to talk through your project?', linkText = 'Get a Free Quote' }) => (
  <div data-testid="inline-cta" className="my-10 border-l-2 border-bronze bg-paper2/70 px-6 py-6">
    <p className="font-serif text-xl italic text-ink">{text}</p>
    <Link to="/get-a-quote/" data-testid="inline-cta-link" className="mt-3 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.15em] text-bronze transition-colors hover:text-ink">
      {linkText} <ArrowRight className="h-4 w-4" />
    </Link>
  </div>
);

export default CTASection;
